import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetDocumentCategoryColumnsParams } from "apis/data-contracts";

const useCategoryColumnsQuery = (options: GetDocumentCategoryColumnsParams) => {
  return useSuspenseQuery({
    queryKey: api.document.getDocumentCategoryColumnsKey(options),
    queryFn: () => api.document.getDocumentCategoryColumns(options),
  });
};

export default useCategoryColumnsQuery;
